import { useOutletContext } from "react-router-dom";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const useReadOnly = () => useOutletContext()?.readOnly || false;

export function Field({ label, value, onChange, type = "text", placeholder, testid, required }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs text-slate-500">{label}{required && <span className="text-red-500"> *</span>}</Label>
      <Input type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testid} />
    </div>
  );
}
